import React from 'react';
import {
  Search, Filter, X, ChevronDown,
} from 'lucide-react';
import { CATEGORIES, BV_OPTIONS, STATUS_OPTIONS } from './constants';

export function FilterBar({ filters, setFilter, clearFilters, hasActiveFilters, locations, mobileFiltersOpen, setMobileFiltersOpen }) {
  return (
    <div className="bg-white dark:bg-[#161B22] rounded-xl border border-slate-200/80 dark:border-[#21262D]" data-testid="kennisbank-filters">
      <button
        className="sm:hidden w-full flex items-center justify-between px-4 py-3"
        onClick={() => setMobileFiltersOpen(!mobileFiltersOpen)}
      >
        <div className="flex items-center gap-2 text-sm text-slate-600 dark:text-[#8B949E]">
          <Filter className="w-4 h-4" />
          Filters
          {hasActiveFilters && <span className="w-2 h-2 rounded-full bg-[#2E75B6]" />}
        </div>
        <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${mobileFiltersOpen ? 'rotate-180' : ''}`} />
      </button>

      <div className={`${mobileFiltersOpen ? 'block' : 'hidden'} sm:block px-3 sm:px-4 py-2 sm:py-3`}>
        <div className="flex flex-wrap items-center gap-2">
          <Filter className="w-4 h-4 text-slate-400 hidden sm:block" />

          <div className="relative w-full sm:w-auto">
            <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400" />
            <input
              data-testid="filter-search"
              type="text"
              value={filters.search}
              onChange={(e) => setFilter('search', e.target.value)}
              placeholder="Zoeken..."
              className="pl-8 pr-3 py-2 sm:py-1.5 rounded-lg border border-slate-200 dark:border-[#30363D] bg-white dark:bg-[#0D1117] text-sm sm:text-xs w-full sm:w-40 focus:outline-none focus:ring-2 focus:ring-[#2E75B6]/30 focus:border-[#2E75B6] transition-colors"
            />
          </div>

          <select data-testid="filter-location" value={filters.location} onChange={(e) => setFilter('location', e.target.value)}
            className="px-2.5 py-2 sm:py-1.5 rounded-lg border border-slate-200 dark:border-[#30363D] bg-white dark:bg-[#0D1117] text-slate-900 dark:text-[#E6EDF3] text-sm sm:text-xs focus:outline-none focus:ring-2 focus:ring-[#2E75B6]/30 focus:border-[#2E75B6] transition-colors w-full sm:w-auto">
            <option value="">Alle locaties</option>
            {locations.map(loc => (<option key={loc.location_id} value={loc.location_id}>{loc.name}</option>))}
          </select>

          <select data-testid="filter-category" value={filters.category} onChange={(e) => setFilter('category', e.target.value)}
            className="px-2.5 py-2 sm:py-1.5 rounded-lg border border-slate-200 dark:border-[#30363D] bg-white dark:bg-[#0D1117] text-slate-900 dark:text-[#E6EDF3] text-sm sm:text-xs focus:outline-none focus:ring-2 focus:ring-[#2E75B6]/30 focus:border-[#2E75B6] transition-colors w-[calc(50%-4px)] sm:w-auto">
            <option value="">Alle categorie&#235;n</option>
            {CATEGORIES.map(cat => (<option key={cat.id} value={cat.id}>{cat.name}</option>))}
          </select>

          <select data-testid="filter-bv" value={filters.bv_id} onChange={(e) => setFilter('bv_id', e.target.value)}
            className="px-2.5 py-2 sm:py-1.5 rounded-lg border border-slate-200 dark:border-[#30363D] bg-white dark:bg-[#0D1117] text-slate-900 dark:text-[#E6EDF3] text-sm sm:text-xs focus:outline-none focus:ring-2 focus:ring-[#2E75B6]/30 focus:border-[#2E75B6] transition-colors w-[calc(50%-4px)] sm:w-auto">
            <option value="">Alle BV's</option>
            {BV_OPTIONS.map(bv => (<option key={bv.id} value={bv.id}>{bv.name}</option>))}
          </select>

          <select data-testid="filter-status" value={filters.status} onChange={(e) => setFilter('status', e.target.value)}
            className="px-2.5 py-2 sm:py-1.5 rounded-lg border border-slate-200 dark:border-[#30363D] bg-white dark:bg-[#0D1117] text-slate-900 dark:text-[#E6EDF3] text-sm sm:text-xs focus:outline-none focus:ring-2 focus:ring-[#2E75B6]/30 focus:border-[#2E75B6] transition-colors w-[calc(50%-4px)] sm:w-auto">
            <option value="">Alle statussen</option>
            {STATUS_OPTIONS.map(s => (<option key={s.id} value={s.id}>{s.name}</option>))}
          </select>

          <select data-testid="filter-source" value={filters.source} onChange={(e) => setFilter('source', e.target.value)}
            className="px-2.5 py-2 sm:py-1.5 rounded-lg border border-slate-200 dark:border-[#30363D] bg-white dark:bg-[#0D1117] text-slate-900 dark:text-[#E6EDF3] text-sm sm:text-xs focus:outline-none focus:ring-2 focus:ring-[#2E75B6]/30 focus:border-[#2E75B6] transition-colors w-[calc(50%-4px)] sm:w-auto">
            <option value="">Alle bronnen</option>
            <option value="manual">Handmatig</option>
            <option value="email">Email</option>
            <option value="document_upload">Document</option>
          </select>

          {hasActiveFilters && (
            <button onClick={clearFilters}
              className="flex items-center gap-1 px-3 py-2 sm:py-1.5 rounded-lg text-sm sm:text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 dark:hover:bg-[#21262D] transition-colors">
              <X className="w-3 h-3" />
              Reset
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
